import { render } from "./SystemHealthScreen.vue?vue&type=template&id=5310e3cc"
import script from "./SystemHealthScreen.vue?vue&type=script&lang=js"
export * from "./SystemHealthScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__